@let aspiracion = cultivo.aspiracion_opu ?? cultivo.fertilizacion_in_vitro_detalle?.aspiracion_opu;
<p class="mb-3 text-sm text-gray-500">Cargue las cantidades directamente en las celdas y avance con Tab o Enter. Totales se actualiza al registrar la producción de embriones.</p>
<app-data-table [columns]="columns" [data]="[cultivo]" [clickableRows]="false" [compact]="true" stickyColumn="donante" (keydown.enter)="avanzar($event)">
  <ng-template appTableCell="donante">{{ etiquetaVaca(aspiracion?.animal_donante) }}</ng-template>
  <ng-template appTableCell="raza">{{ aspiracion?.animal_donante?.raza_nombre || aspiracion?.animal_donante?.raza_codigo || '—' }}</ng-template>
  <ng-template appTableCell="toro">{{ aspiracion?.toro_fecundador?.nombre }}</ng-template>
  <ng-template appTableCell="viables">{{ aspiracion?.viables }}</ng-template>
  <ng-template appTableCell="ovocitos">{{ aspiracion?.total_lab }}</ng-template>
  <ng-template appTableCell="cultivados">
    @if (cultivados; as fila) {
      <div [formGroup]="fila.form" class="w-28">
        <app-label class="sr-only" for="pive-cultivados">Ovocitos cultivados</app-label>
        <app-input-field id="pive-cultivados" formControlName="cantidad" type="number" [min]="0" [step]="1" [error]="fila.form.get('cantidad')!.invalid && fila.form.get('cantidad')!.touched" />
        <span class="text-xs text-gray-500">{{ fila.form.get('fecha_control')!.value | date:'dd/MM/yyyy' }}</span>
      </div>
    }
  </ng-template>
  <ng-template appTableCell="clivados">
    @if (clivados; as fila) {
      <div [formGroup]="fila.form" class="w-28">
        <app-label class="sr-only" for="pive-clivados">Clivados</app-label>
        <app-input-field id="pive-clivados" formControlName="cantidad" type="number" [min]="0" [step]="1" [error]="fila.form.get('cantidad')!.invalid && fila.form.get('cantidad')!.touched" />
        <span class="text-xs text-gray-500">{{ fila.form.get('fecha_control')!.value | date:'dd/MM/yyyy' }}</span>
      </div>
    }
  </ng-template>
  <ng-template appTableCell="totales">{{ totalProducido(cultivo) ?? '—' }}</ng-template>
  <ng-template appTableCell="observaciones">
    <div class="min-w-56">
      <app-label class="sr-only" for="pive-observaciones">Observaciones</app-label>
      <app-input-field id="pive-observaciones" [formControl]="observacion" />
    </div>
  </ng-template>
  <ng-template appTableCell="porcentaje">
    @let porcentaje = porcentajeProduccion(totalProducido(cultivo), controlDeEtapa(cultivo, 1)?.cantidad ?? null);
    {{ porcentaje === null ? '—' : (porcentaje | number:'1.1-1') + '%' }}
  </ng-template>
</app-data-table>

<div class="mt-4">
  <app-salidas-frescas [filas]="frescos" [puedeCrear]="canCreate" [puedeEliminar]="canDelete"
    [guardando]="saving" (agregar)="agregarFresco()" (eliminar)="eliminarFresco($event)" />
</div>

<!-- La tabla de controles queda siempre a la vista, sin acordeón.
<app-accordion class="block mt-4" title="Previsión, congelamiento y observaciones"> -->
<div class="mt-4">
  <!-- <app-data-table [columns]="controlColumns" [data]="filas" ...> -->
  <h4 class="mb-2 text-sm font-semibold text-gray-800 dark:text-white/90">Congelamiento · PM6 / AM7 / PM7</h4>
  <app-data-table [columns]="controlColumns" [data]="filasTabla" [clickableRows]="false" [compact]="true" stickyColumn="nombre" [rowExpanded]="expandida" (keydown.enter)="avanzar($event)">
    <ng-template appTableCell="fecha" let-fila>
      <span class="whitespace-nowrap">{{ fila.form.get('fecha_control').value | date:'dd/MM/yyyy' }}</span>
    </ng-template>
    @for (campo of campos; track campo) {
      <ng-template [appTableCell]="campo" let-fila>
        @if (visible(fila, campo)) {
          <div [formGroup]="fila.form" [class]="campo === 'param_estadio_embrionario_id' ? 'min-w-48' : 'w-24'">
            <app-label class="sr-only" [for]="'control-' + fila.id + '-' + campo">{{ fila.nombre }} · {{ campo === 'param_estadio_embrionario_id' ? 'Estadio' : campo }}</app-label>
            @if (campo === 'param_estadio_embrionario_id') {
              <app-select [id]="'control-' + fila.id + '-' + campo" [formControlName]="campo" [options]="estadiosOptions" [allowEmpty]="true" [error]="fila.form.get(campo).invalid && fila.form.get(campo).touched" />
            } @else {
              <app-input-field [id]="'control-' + fila.id + '-' + campo" [formControlName]="campo" type="number" [min]="campo === 'grado' ? 1 : 0" [step]="1" [error]="fila.form.get(campo).invalid && fila.form.get(campo).touched" />
            }
          </div>
        } @else if (!siempreAbierta(fila)) { — }
      </ng-template>
    }
    <ng-template appTableCell="observacion" let-fila>
      <div [formGroup]="fila.form" class="min-w-48">
        <app-label class="sr-only" [for]="'observacion-' + fila.id">Observaciones · {{ fila.nombre }}</app-label>
        <app-input-field [id]="'observacion-' + fila.id" formControlName="observacion" />
      </div>
    </ng-template>
    <ng-template appTableCell="produccion" let-fila>
      @if (fila.produccion && siempreAbierta(fila)) {
        <span class="whitespace-nowrap text-xs text-gray-500">
          @if (fila.produccion.salida; as salida) {
             {{ salida.nro_embriones }} · Congelado
          } @else { Cargar abajo }
        </span>
      } @else if (fila.produccion; as produccion) {
        <button type="button" class="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-gray-300 px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
          [attr.aria-expanded]="expandida(fila)" (click)="toggleProduccion(fila)">
          <span aria-hidden="true">{{ expandida(fila) ? '▾' : '▸' }}</span>
          @if (produccion.salida; as salida) {
             {{ salida.nro_embriones }} · Congelado
          } @else if (!produccion.readOnly) {
            Registrar
          } @else {
            Sin producción
          }
          @if (produccion.pendiente) { <span class="size-2 rounded-full bg-amber-500" title="Cambios sin guardar"></span> }
        </button>
      } @else { — }
    </ng-template>
    <ng-template appTableRowDetail let-fila>
      <app-produccion-etapa [modelo]="fila.produccion" [canDelete]="canDelete" [deshabilitado]="saving"
        [controlForm]="siempreAbierta(fila) ? fila.form : undefined" [estadiosOptions]="estadiosOptions"
        [tecnicasCongelamientoOptions]="tecnicasCongelamientoOptions" [opsPuntosOptions]="opsPuntosOptions"
        [opsColoresOptions]="opsColoresOptions" (eliminar)="eliminarProduccion(fila.produccion)" />
    </ng-template>
  </app-data-table>
</div>
<!-- </app-accordion> -->
@for (fila of filas; track fila.id) {
  @if (fila.error) { <p role="alert" class="mt-2 text-sm text-red-600">{{ fila.nombre }}: {{ fila.error }}</p> }
  @if (fila.produccion?.error) { <p role="alert" class="mt-2 text-sm text-red-600">Producción {{ fila.produccion!.nombre }}: {{ fila.produccion!.error }}</p> }
}
@if (errorObservacion) { <p role="alert" class="mt-2 text-sm text-red-600">{{ errorObservacion }}</p> }
@if (canCreate || canEdit) {
  <div class="mt-4 flex justify-end gap-3">
    <app-button size="sm" variant="outline" [disabled]="saving || !pendientes" (btnClick)="restablecer()">Descartar cambios</app-button>
    <app-button size="sm" [loading]="saving" [disabled]="!pendientes" (btnClick)="guardar()">Guardar cambios ({{ pendientes }})</app-button>
  </div>
}
